import { FormEvent, useEffect, useState } from 'react';
import { IListItem } from '@nkr/models/index'
import { Alert, Button, Col, ControlLabel, Form, FormControl, FormGroup, Modal } from 'react-bootstrap'
import usePrevious from '@nkr/services/use-previous';

interface IProps {
    show: boolean,
    alias: string,
    reasonList: IListItem[],
    onSubmit: (reasonCode: number, reason: string, initials: string) => void,
    onCancel: () => void
}

const ConfirmDeleteModal = (props: IProps) => {
    const [reasonCode, setReasonCode] = useState(-1);
    const [reason, setReason] = useState('');
    const [initials, setInitials] = useState('');
    const [validation, setValidation] = useState({ reasonCode: true, reason: true, initials: true });
    const [dirty, setDirty] = useState(true);

    const previousShow = usePrevious(props.show);

    useEffect(() => {
        if (previousShow == false && props.show == true) {
            setReasonCode(-1);
            setReason('');
            setInitials('');
            setValidation({ reasonCode: true, reason: true, initials: true });
            setDirty(false);
        }
    }, [props.show]);

    const handleFieldChange = (e: FormEvent<FormControl & HTMLInputElement & HTMLSelectElement>) => {
        let { name, value } = e.currentTarget;

        if (name == 'reasonCode') {
            setReasonCode(parseInt(value));
        }

        if (name == 'reason') {
            setReason(value);
        }

        if (name == 'initials') {
            setInitials(value);
        }
    };

    const handleSubmit = () => {
        let validation = {
            reasonCode: reasonCode >= 0,
            reason: reasonCode == 0 ? reason != '' : true,
            initials: initials != ''
        }

        setValidation(validation);
        setDirty(true);

        if (validation.reasonCode && validation.reason && validation.initials) {
            props.onSubmit(reasonCode, reason, initials);
        }
    };

    const isValid = validation.reasonCode && validation.reason && validation.initials;

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>Please Confirm Recipient Deletion</Modal.Header>
            <Modal.Body>
                {dirty && !isValid && (
                    <Alert bsStyle='danger' bsSize='sm'>
                        The items in red are required to continue...
                    </Alert>
                )}

                {props.alias != '' && (
                    <blockquote>Alias: {props.alias}</blockquote>
                )}

                <Form horizontal>
                    <FormGroup validationState={dirty && validation.reasonCode == false ? 'error' : null}>
                        <Col xs={12} lg={4} componentClass={ControlLabel}>Reason for Deletion:</Col>
                        <Col xs={12} lg={8}>
                            <FormControl
                                componentClass='select'
                                name='reasonCode'
                                value={reasonCode}
                                onChange={handleFieldChange}
                            >
                                <option value={-1}>- Please Select -</option>
                                {props.reasonList.map(item =>
                                    <option key={'reason-' + item.id} value={item.id}>{item.description}</option>
                                )}
                            </FormControl>
                        </Col>
                    </FormGroup>

                    {reasonCode == 0 && (
                        <FormGroup validationState={dirty && validation.reason == false ? 'error' : null}>
                            <Col xs={12} lg={4} componentClass={ControlLabel}><i>Other</i> Details:</Col>
                            <Col xs={12} lg={8}>
                                <FormControl
                                    componentClass='textarea'
                                    name='reason'
                                    style={{ resize: 'none', height: 100 }}
                                    value={reason}
                                    onChange={handleFieldChange}
                                />
                            </Col>
                        </FormGroup>
                    )}

                    <FormGroup validationState={dirty && validation.initials == false ? 'error' : null}>
                        <Col xs={12} lg={4} componentClass={ControlLabel}>Your Initials:</Col>
                        <Col xs={12} lg={8}>
                            <FormControl
                                name='initials'
                                value={initials}
                                onChange={handleFieldChange}
                            />
                        </Col>
                    </FormGroup>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='danger' onClick={handleSubmit}>Confirm Deletion</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmDeleteModal;